import { ref } from 'vue'

// Menu
const menu = ref({
  isOpen : false
});

const useMenu = {
  open() {
    document.body.classList.add('showMenu')
    document.body.style.overflow = "hidden"
    menu.value.isOpen = true
  },
  close() {
    document.body.classList.remove('showMenu')
    document.body.style.overflow = ""
    menu.value.isOpen = false
  }
};

export { menu, useMenu }
